import { PhraseService } from "../service/service";
import { PhraseAdapter } from "../store/adapter";
import { NotificationService } from "@/shared";
import { LoadingController } from "@/shared/service/loading";
import * as dto from "../dto";

class PhraseController {
  constructor(
    private readonly phraseService: PhraseService,
    private readonly notificationService: NotificationService,
    private readonly storeAdapter: PhraseAdapter,
    private readonly loadingController: LoadingController
  ) {}

  public getPhrases(params: dto.GetPhasesParamsDto) {
    this.loadingController.activeFetchLoading();
    this.phraseService
      .fethPhrases(params)
      .then((response) => {
        if (response.status === "success" && response.data) {
          this.storeAdapter.setPhraseList(response.data.phraseTranslations);

          if (response.data.currentCount) {
            this.storeAdapter.setTotalCount(response.data.currentCount);
          }
          
        } else {
          throw response.message;
        }
      })
      .catch(
        (error) => (
          console.error(error),
          this.notificationService.activeNotification({
            status: "error",
            message: `Ошибка: ${error}`,
          })
        )
      )
      .finally(() => this.loadingController.resetFethLoading());
  }

  public getPhrase(id: string | undefined) {
    this.sendErrorGetID(id);
    if (!id) return;

    this.loadingController.activeFetchLoading();
    this.phraseService
      .fethPhrase(id)
      .then((response) => {
        if (response.status === "success" && response.data) {
          this.storeAdapter.setCurrentPhras(response.data.phraseTranslation);
        } else {
          throw response.message;
        }
      })
      .catch(
        (error) => (
          console.error(error),
          this.notificationService.activeNotification({
            status: "error",
            message: `Ошибка: ${error}`,
          })
        )
      )
      .finally(() => this.loadingController.resetFethLoading());
  }

  public createPhrase(payload: dto.CreatePhraseDto) {
    return new Promise((resolve) => {
      this.storeAdapter.setLoadingSubmit();
      this.phraseService
        .fetchCreatePhrase(payload)
        .then((response) => {
          if (response.status === "success" && response.data) {
            this.notificationService.activeNotification({
              status: "success",
              message: "Перевод успешно добавлен",
            });
          } else {
            throw response.message;
          }
          return resolve(response.status);
        })
        .catch(
          (error) => (
            console.error(error),
            this.notificationService.activeNotification({
              status: "error",
              message: `Ошибка: ${error}`,
            })
          )
        )
        .finally(() => this.storeAdapter.resetLoadingSumbmit());
    });
  }

  public editPhrase(payload: { id: string; payload: dto.EditPhaseDto }) {
    return new Promise((resolve) => {
      this.sendErrorGetID(payload.id);
      if (!payload.id) return;

      this.storeAdapter.setLoadingSubmit();
      this.phraseService
        .fethEditPhrase(payload)
        .then((response) => {
          if (response.status === "success" && response.data) {
            this.storeAdapter.setCurrentPhras(response.data.phraseTranslation);
            this.notificationService.activeNotification({
              status: "success",
              message: "Перевод успешно обновлен",
            });
            return resolve(response.status);
          } else {
            throw response.message;
          }
        })
        .catch(
          (error) => (
            console.error(error),
            this.notificationService.activeNotification({
              status: "error",
              message: `Ошибка: ${error}`,
            })
          )
        )
        .finally(() => this.storeAdapter.resetLoadingSumbmit());
    });
  }

  public removePhrase(id: string) {
    this.sendErrorGetID(id);
    if (!id) return;

    this.storeAdapter.setLoadingSubmit();
    this.phraseService
      .fethRemovePhrase(id)
      .then((response) => {
        if (response.status === "success" && response.data) {
          this.storeAdapter.filterById(id);

          this.notificationService.activeNotification({
            status: "success",
            message: "Перевод успешно удален",
          });
        } else {
          throw response.message;
        }
      })
      .catch(
        (error) => (
          console.error(error),
          this.notificationService.activeNotification({
            status: "error",
            message: `Ошибка: ${error}`,
          })
        )
      )
      .finally(() => this.storeAdapter.resetLoadingSumbmit());
  }

  public getTranslate(params: dto.TranslatePayloadSchemaDto) {
    this.loadingController.activeFetchLoading();
    this.phraseService
      .fethTranslate(params)
      .then((response) => {
        if (response.status === "success" && response.data) {
          this.storeAdapter.setCurrentTranslate(
            response.data.phraseTranslation
          );
        } else {
          throw response.message;
        }
      })
      .catch(
        (error) => (
          console.error(error),
          this.notificationService.activeNotification({
            status: "error",
            message: `Ошибка: ${error}`,
          })
        )
      )
      .finally(() => this.loadingController.resetFethLoading());
  }

  public getTranslates(params: dto.TranslatesPayloadSchemaDto) {
    this.loadingController.activeFetchLoading();
    this.phraseService
      .fethTranslates(params)
      .then((response) => {
        if (response.status === "success" && response.data) {
          console.log(response);
          this.storeAdapter.setTranslateList(response.data.phraseTranslations);
        } else {
          throw response.message;
        }
      })
      .catch(
        (error) => (
          console.error(error),
          this.notificationService.activeNotification({
            status: "error",
            message: `Ошибка: ${error}`,
          })
        )
      )
      .finally(() => this.loadingController.resetFethLoading());
  }

  private sendErrorGetID(id: string | undefined) {
    if (!id) {
      this.notificationService.activeNotification({
        status: "error",
        message: "Ошибка: ID не найден",
      });
    }
  }
}

export const phraseController = new PhraseController(
  new PhraseService(),
  new NotificationService(),
  new PhraseAdapter(),
  new LoadingController()
);
